import React from "react";
import { FormattedMessage } from "react-intl";
import { navigateToLogout, navigateToApplication } from "../../redux/helpers/navigators";
import { NewFADVLoginForm } from "./NewFADVLoginForm";
import { useDispatch, useSelector } from "react-redux";
import { setFetching } from "../../redux/actions/loginactioncreators";

export function ExistingSession() {
  const secondsBeforeRetryAvailable = 10;
  const dispatch = useDispatch();
  const baseUrl = useSelector(state => state.loginForm.baseUrl);

  const handleSignOut = () => {
    navigateToLogout();
    setSpinner();
  };

  const handleStaySignedIn = () => {
    navigateToApplication();
    setSpinner();
  };

  const setSpinner = (seconds=secondsBeforeRetryAvailable) => {
    dispatch(setFetching(true));
    setTimeout(() => dispatch(setFetching(false)), seconds * 1000);
  }

  return (
    <NewFADVLoginForm
      headerContent={<FormattedMessage id="login.existingSessionTitle" defaultMessage="Existing Session" description="Header text for interstitial dialog when an existing session is detected." />}
      submitButtonText={<FormattedMessage id="login.staySignedIn" defaultMessage="Stay signed in" description="Button to stay signed in and disconnect other session." />}
      onSubmit={handleStaySignedIn}
      secondaryButtonText={<FormattedMessage id="login.signOut" defaultMessage="Sign out" description="Button to sign out the existing session." />}
      secondaryButtonHandler={handleSignOut}
      secondaryButtonId="existingSessionSignOut"
      showErrors={false}
    >
      <div className="flex flex-col justify-center items-center">
        <img src={`${baseUrl}/assets/fa-alert.svg`} />
      </div>
      <div className="flex font-medium text-lg justify-center">
        <div id="existingSessionMessage" className="w-full md:w-3/4 lg:w-1/2 text-center">
        <FormattedMessage
          id="login.existingSession"
          defaultMessage="This username is already in use. Would you like to disconnect them so you may stay signed in?"
          description="Message shown when an existing session is detected."
        />
        </div>
      </div>
    </NewFADVLoginForm>
  );
}